import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { DataTablesModule } from 'angular-datatables';
import { HighchartsChartModule } from 'highcharts-angular';
import { BaseChartDirective } from 'ng2-charts';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../../../../shared/shared.module';
import { EnitComplainceRoutingModule } from '../../eComplaince-routing.module';
import { CtclModule } from '../../EnitTrade/ctcl/ctcl.module';
import { TradeAdminRoutingModule } from '../../tradeAdmin-routing.module';
import { AdminHalfYearlyReportComponent } from './admin-half-yearly-report/admin-half-yearly-report.component';
import { HalfYearlyFormSubmissionHistoryComponent } from './half-yearly-form-submission-history/half-yearly-form-submission-history.component';
import { HalfYearlyFormSubmissionComponent } from './half-yearly-form-submission/half-yearly-form-submission.component';
import { HalfYearlyMemberListComponent } from './half-yearly-member-list/half-yearly-member-list.component';
import { MemberHalfYearlyReportComponent } from './member-half-yearly-report/member-half-yearly-report.component';






@NgModule({
  declarations: [
    
    AdminHalfYearlyReportComponent,
    HalfYearlyFormSubmissionComponent,
    HalfYearlyFormSubmissionHistoryComponent,
    HalfYearlyMemberListComponent,
    MemberHalfYearlyReportComponent


  ],
  imports: [
    
    CommonModule,
    TradeAdminRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    CtclModule,
    EnitComplainceRoutingModule,
    AgGridModule,
    BaseChartDirective,
    HighchartsChartModule
  ]
})
export class HalfYearlyModule { }
